module.exports = __webpack_public_path__ + "img/invoicedocument.36ec418c.png";